export default function CreateContact({ handleFormClose, FormOpener }) {
  return (
    <div
      id="CreatContact"
      className={FormOpener ? "overlay-note w100 " : "overlay-note"}>
      <div className="overlay-add-deals contact-right-side">
        <div className="note-title">
          <h4 className="text-left text-white pl-3">Create Contact</h4>
          <a
            className="closebtn text-right text-white"
            onClick={handleFormClose}>
            &times;
          </a>
        </div>

        <div className="contact-body modify-create-contact">
          {/*   <!--  <h6><i className="fas fa-ellipsis-v more-dot fa-sm"></i> classNameification   </h6> -->
           */}
          <div className="form-group">
            <label>
              Enquiry for:<b>*</b>
            </label>
            <select className="form-control">
              <option value="">Study Abroad</option>
              <option value="">Ielts</option>
              <option value="">PTE</option>
              <option value="">Migration</option>
            </select>
          </div>

          <div className="form-group">
            <label>
              Lead source:<b>*</b>
            </label>
            <select className="form-control">
              <option value="">Student </option>
              <option value="">Agent</option>
              <option value="">Internal</option>
            </select>
          </div>

          {/*     <h6><i className="fas fa-ellipsis-v more-dot fa-sm"></i> Basic Information   </h6>*/}

          <div className="form-group">
            <label>
              Name:<b>*</b>
            </label>
            <input type="text" className="form-control" placeholder="Enter name" />
          </div>

          <div className="form-group first-input">
            <label>
              Telephone:<b>*</b>
            </label>
            <button className="first-btn-plus" value="+">
              {" "}
              +{" "}
            </button>
            <input
              type="text"
              name=" "
              className="form-control"
              placeholder="Enter Phone number"
            />
          </div>
          <div className="form-group Second-input">
            <button className="second-btn-plus" value="+">
              {" "}
              +{" "}
            </button>

            <button className="second-btn-minus" value="-">
              {" "}
              -{" "}
            </button>
            <input
              type="text"
              name=" "
              className="form-control"
              placeholder="Enter Phone number"
            />
          </div>
          <div className="form-group third-input">
            <button className="third-btn-minus" value="-">
              {" "}
              -{" "}
            </button>
            <input
              type="text"
              name=" "
              className="form-control"
              placeholder="Enter Phone number"
            />
          </div>

          <div className="form-group first-input-email">
            <label>
              Email:<b>*</b>
            </label>
            <button className="first-btn-plus-email" value="+">
              {" "}
              +{" "}
            </button>
            <input
              type="email"
              name=" "
              className="form-control"
              placeholder="Enter email"
            />
          </div>
          <div className="form-group Second-input-email ">
            <button className="second-btn-plus-email" value="+">
              {" "}
              +{" "}
            </button>

            <button className="second-btn-minus-email" value="-">
              {" "}
              -{" "}
            </button>
            <input
              type="email"
              name=" "
              className="form-control"
              placeholder="Enter email"
            />
          </div>
          <div className="form-group third-input-email">
            <button className="third-btn-minus-email" value="-">
              {" "}
              -{" "}
            </button>
            <input
              type="email"
              name=" "
              className="form-control"
              placeholder="Enter email"
            />
          </div>

          <div className="form-group">
            <label>
              Date Of Birth:<b>*</b>
            </label>
            <input
              type="text"
              className="datepicker form-control"
              name="date19"
              placeholder="DD/MM/YYYY"
            />
          </div>

          <div className="form-group">
            <label>
              Gender:<b>*</b>
            </label>
            <select className="form-control">
              <option value="">Male</option>
              <option value=""> Female </option>
              <option value=""> Other </option>
            </select>
          </div>

          <div className="form-group">
            <label>
              Marital Status:<b>*</b>
            </label>
            <select className="form-control">
              <option value="">unmarried</option>
              <option value="">married </option>
            </select>
          </div>

          <div className="form-group">
            <label>
              City:<b>*</b>
            </label>
            <input type="text" className="form-control" placeholder="Enter City" />
          </div>

          <div className="form-group">
            <label>
              State:<b>*</b>
            </label>
            <input type="text" className="form-control" placeholder="Enter City" />
          </div>

          <div className="form-group">
            <label>
              Country:<b>*</b>
            </label>
            <select className="form-control">
              <option value="">List few countries</option>
              <option value="">India</option>
              <option value="">Nepal</option>
              <option value="">Australia</option>
              <option value="">Chile</option>
              <option value="">China</option>
              <option value="">Afghanistan</option>
              <option value="">Bangladesh </option>
            </select>
          </div>

          <div className="form-group">
            <label>
              How did you hear about us:<b>*</b>
            </label>
            <select className="form-control">
              <option value="">---</option>
              <option value=""> </option>
            </select>
          </div>

          <div className="form-group">
            <label>
              {" "}
              Preferred Destination I:<b>*</b>
            </label>
            <select className="form-control">
              <option value="">---</option>
              <option value="">Australia</option>
              <option value="">New Zealand </option>
              <option value="">UK</option>
              <option value="">Ireland</option>
              <option value="">Canada</option>
              <option value="">France</option>
              <option value="">Spain</option>
              <option value="">Germany</option>
              <option value="">Italy</option>
              <option value="">USA</option>
              <option value="">Others</option>
            </select>
          </div>

          <div className="form-group">
            <label>
              {" "}
              Preferred Destination II:<b>*</b>
            </label>
            <select className="form-control">
              <option value="">---</option>
              <option value="">Australia</option>
              <option value="">New Zealand </option>
              <option value="">UK</option>
              <option value="">Ireland</option>
              <option value="">Canada</option>
              <option value="">France</option>
              <option value="">Spain</option>
              <option value="">Germany</option>
              <option value="">Italy</option>
              <option value="">USA</option>
              <option value="">Others</option>
            </select>
          </div>

          <div className="form-group">
            <label>
              {" "}
              Rating:<b>*</b>
            </label>
            <select className="form-control">
              <option value="">---</option>
              <option value=""> </option>
            </select>
          </div>

          <div className="form-group">
            <label>
              {" "}
              Qualify:<b>*</b>
            </label>
            <select className="form-control">
              <option value="">---</option>
              <option value=""> </option>
            </select>
          </div>

          <div className="form-group">
            <label>
              {" "}
              Primary contact owner:<b>*</b>
            </label>
            <select className="form-control">
              <option value="">---</option>
              <option value=""> </option>
            </select>
          </div>

          <div className="form-group">
            <label>
              {" "}
              secondary Contact owner:<b>*</b>
            </label>
            <select className="form-control">
              <option value="">---</option>
              <option value=""> </option>
            </select>
          </div>

          <div className="form-group">
            <label>
              {" "}
              Branch:<b>*</b>
            </label>
            <select className="form-control">
              <option value="">Delhi - India </option>
              <option value="">Sri Nagar - India </option>
              <option value="">Chandigarh - India </option>
              <option value="">kathmandu - Nepal </option>
              <option value="">Mahendranagar - Nepal </option>
              <option value="">Dang - Nepal </option>
              <option value="">Sydney - Australia </option>
              <option value="">Santiago - Chile </option>
            </select>
          </div>

          <div className="contact-footer w-100">
            <button type="button" className="btn">
              Create contact
            </button>
            <button type="button" className="btn">
              Create and add another
            </button>
            <button
              type="button"
              className="btn btn-deep-orange waves-effect waves-light"
              onClick={handleFormClose}>
              Cancel
            </button>
          </div>
        </div>
        {/*<!-- contact-body -->*/}
      </div>
    </div>
  );
}
